import { RecurrenceStatusStatus, RegistrationTypeType, Status } from '@wix/ambassador-events-v3-event/types';
const RECURRING_STATUSES = [
    RecurrenceStatusStatus.RECURRING,
    RecurrenceStatusStatus.RECURRING_RECENTLY_CANCELED,
    RecurrenceStatusStatus.RECURRING_RECENTLY_ENDED,
    RecurrenceStatusStatus.RECURRING_UPCOMING,
];
export const getFormattedLocation_V3 = (event) => (event.location.name || event.location.address?.formattedAddress) ?? '';
export const isDraft_V3 = (event) => event.status === Status.DRAFT;
export const isCanceled_V3 = (event) => event.status === Status.CANCELED;
export const isPast_V3 = (event) => event.status === Status.ENDED;
export const isStarted_V3 = (event) => event.status === Status.STARTED;
export const isUpcoming_V3 = (event) => event.status === Status.UPCOMING;
export const isRecurringEvent_V3 = (event) => RECURRING_STATUSES.includes(getRecurrenceStatus_V3(event));
export const getRecurrenceStatus_V3 = (event) => event.dateAndTimeSettings.recurrenceStatus;
export const isPastAndDraft_V3 = (event) => isDraft_V3(event) && isPast_V3(event);
export const isTicketed_V3 = (event) => event.registration.type === RegistrationTypeType.TICKETING;
export const isUpcomingOrStarted_V3 = (event) => isStarted_V3(event) || isUpcoming_V3(event);
export const isDateTbd_V3 = (event) => Boolean(event.dateAndTimeSettings.dateAndTimeTbd);
export const getStartDate_V3 = (event) => event.dateAndTimeSettings.startDate;
export const getEndDate_V3 = (event) => event.dateAndTimeSettings.endDate;
export const hasVisibleTicketDefinitions_V3 = (event) => event.registration.tickets.lowestPrice !== undefined;
export const getRecurringCategoryId_V3 = (event) => event.dateAndTimeSettings?.recurringEvents?.categoryId;
export const getEventTimeZoneId_V3 = (event) => event.dateAndTimeSettings.timeZoneId;
export const getShowTimeZone_V3 = (event) => event.dateAndTimeSettings.showTimeZone;
export const getTicketsSold = (event) => event.summaries?.tickets?.ticketsSold ?? 0;
